import { globalState } from '../../models';
// baseUrl 1.仅二级路径 2.站点+二级路径
export const getBaseUrl = () => globalState.origin || '';
